import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spiritual-hints',
  templateUrl: './spiritual-hints.component.html',
  styleUrls: ['./spiritual-hints.component.css']
})
export class SpiritualHintsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
